export default __webpack_public_path__ + "static/media/rewind.cb097849.svg";